import { InferGetStaticPropsType } from "next";
import Link from "next/link";

import { AppShell } from "@chef/feature-app-shell";
import { BRAND_PATHS } from "@chef/constants";
import { Card } from "@chef/components";
import { capitalize } from "@chef/utils/string";

import { Breadcrumbs } from "../components/Breadcrumbs";
import { CategoriesPageGetStaticProps, intl } from "..";

export const CategoriesPage = ({
  categories,
  breadcrumbs,
}: InferGetStaticPropsType<typeof CategoriesPageGetStaticProps>) => {
  return (
    <AppShell title={capitalize(intl.CATEGORIES)}>
      <AppShell.Meta />
      <AppShell.Drawer />
      <AppShell.Header />
      <AppShell.Main>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
        {categories.map((category) => {
          return (
            <div key={category.parent.value} className="mb-20">
              <Link
                href={`${BRAND_PATHS.RECIPE_HUB_PATH}/${category.parent.slug}`}
              >
                <h2 className="mt-10 text-2xl underline underline-offset-2 decoration-2 text-primary">
                  <strong>{category.parent.value}</strong>
                </h2>
              </Link>
              <div className="grid grid-cols-1 gap-2 mt-4 lg:gap-4 md:grid-cols-2 xl:grid-cols-3">
                {category.children.map((child) => {
                  return (
                    <Link
                      key={child.value}
                      href={`${BRAND_PATHS.RECIPE_HUB_PATH}/${category.parent.slug}/${child.slug}`}
                    >
                      <Card key={child.value} className="flex">
                        <h3 className="mb-1">
                          <strong>{child.value}</strong>
                        </h3>
                      </Card>
                    </Link>
                  );
                })}
              </div>
            </div>
          );
        })}
      </AppShell.Main>
      <AppShell.Footer />
    </AppShell>
  );
};
